//this is generic component for sending events to subApps (i.e. language update)
export const dispatchMfeEvent = (eventName, eventPayload) => {
    const newEvent = new CustomEvent(eventName, { detail: eventPayload });
    window.dispatchEvent(newEvent);
};
